import Vue from 'vue'

export default Vue.filter('cropWord', (value, maxLength) => {
  if (!value) return ''
  if (value.length <= maxLength) return value
  return `${value.split('').slice(0, maxLength).join('')}...`
})
